import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { NoteDTO } from '../../core/models/dto/note.dto';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'reversePaging' })
export class ReversePagingPipe implements PipeTransform {
    transform(items: NoteDTO[], itemsLength, count: number, isShowAllComments = false, isAscSort = false): Array<any> {
        const sliceStart = isShowAllComments ? 0 : items.length - count;
        const sliceEnd = isShowAllComments ? items.length : count;

        if (isAscSort) {
            return items.slice(sliceStart < 0 ? 0 : sliceStart, items.length);
        } else {
            return items.slice(0, sliceEnd);
        }
    }
}
